/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="14"
        height="18"
        viewBox="0 0 14 18"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M5.8 8.38a4.63 4.63 0 0 0 .48-.14 7.24 7.24 0 0 0 4.55-6L9.19 3.41l-.65-1L11.73 0l2.24 3.44-.94.7-1.06-1.64a8.57 8.57 0 0 1-4.5 6.55 8.61 8.61 0 0 1 4.35 6.53l1.25-1.95.93.71-2.37 3.68-3.38-2.58.65-1 1.78 1.35a7.21 7.21 0 0 0-4.86-6.12l-.53.11a10.57 10.57 0 0 1-2.18 0v-.39H-.01V8.18a50.92 50.92 0 0 1 5.21.05 5.6 5.6 0 0 1 .59.12ZM0 8.18h7.78L6.22 9l1.56.82H0Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'RightArrowSplitIcon';

export default Icon;
